import { Injectable } from '@angular/core';
import { ThemeService } from './theme.service';
import { LanguageService } from './language/language.service';

@Injectable()
export class AppService {
    constructor(
        private themeService: ThemeService,
        private languageService: LanguageService,
    ) {}

    initStoreData() {
        this.themeService.initTheme();
        this.languageService.initLanguage();
    }
}
